import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";
import { ReportComponentsResponse } from "../../types/ReportTypes";

// Without report ID returns products waiting for the next report
export default function useGetReportComponents(
  reportId: number | null,
  enabled = true
) {
  return useQuery({
    queryKey: ["reportComponents", reportId],
    queryFn: async () => {
      return axiosInstance
        .get(`/reports/${reportId ?? "pending"}`)
        .then((res) => res.data);
    },
    enabled,
    select: (data: ReportComponentsResponse) => data,
    retry: false,
  });
}
